<template>
  <!-- TODO: 红色显示超时未回复访客 -->
  <!-- TODO: 未小结的会话保存在某个界面，或明显位置提示，待客服方便的时候统一小结 -->
  <!-- TODO: 如果是技能组会话，则显示当前技能组 -->
  <div id="bd-aside">
    <div class="thread-search">
      <el-input
        style="width: 80%;"
        size="mini"
        :placeholder="searchTip"
        suffix-icon="el-icon-search"
        v-model="search"
        @change="handleSearchChange"
        clearable
      ></el-input>
      <el-tooltip
        class="item"
        effect="dark"
        :content="refreshThreadsTip"
        placement="top-start"
      >
        <el-button
          style="float: right;"
          size="mini"
          icon="el-icon-refresh"
          circle
          @click="manualRefreshData()"
        ></el-button>
      </el-tooltip>
    </div>
    <div style="height: calc(100% - 60px); overflow-y: auto;">
      <el-alert
        v-if="!networkConnected"
        :title="networkErrorTip"
        type="warning"
      ></el-alert>
      <el-alert
        v-if="isPullingUnreadMessage"
        :title="pullingMessageTip"
        type="warning"
      ></el-alert>
      <el-collapse v-model="activeNames" @change="handleChange">
        <!-- channel -->
        <el-collapse-item name="0" v-if="channelThreads.length > 0">
          <template slot="title">
            <div style="margin-left: 20px;">{{ collapseChannelTitle }}</div>
          </template>
          <li
            v-for="thread in channelThreads"
            :key="thread.topic"
            class="list-item"
            :class="{ ' active': thread.topic === userCurrentThread.topic }"
            @click.exact="selectThread(thread)"
          >
            <div class="list-left">
              <el-badge
                v-if="thread.unreadCount > 0"
                :value="thread.unreadCount"
                :max="99"
                class="item"
              >
                <el-avatar size="medium" :src="thread.avatar"></el-avatar>
              </el-badge>
              <el-avatar v-else size="medium" :src="thread.avatar"></el-avatar>
              <!-- <img v-if="thread.unreadCount === 0" class="avatar" width="40" height="40" :alt="thread.nickname"
                :src="thread.avatar" /> -->
            </div>
            <div class="list-right">
              <div class="top">
                <span class="nickname">
                  <!-- {{ thread.nickname }} -->
                  {{ getThreadNickname(thread) }}
                  <i
                    v-if="isNodisturbThread(thread)"
                    class="el-icon-remove-outline"
                  ></i>
                </span>
                <span class="timestamp">
                  {{ thread.timestamp | time }}
                </span>
              </div>
              <div class="bottom">
                <span class="content">
                  {{ showContent(thread) }}
                </span>
              </div>
            </div>
          </li>
        </el-collapse-item>
        <!-- 置顶会话 -->
        <el-collapse-item name="1" v-if="userTopThreads.length > 0">
          <template slot="title">
            <div style="margin-left: 20px;">{{ collapseTopTitle }}</div>
          </template>
          <li
            v-for="thread in userTopThreads"
            :key="thread.tid"
            class="list-item"
            :class="{ ' active': thread.topic === userCurrentThread.topic }"
            @click.exact="selectThread(thread)"
            @click.right="rightEvent(thread)"
            @contextmenu="onTopContextmenu"
          >
            <div class="list-left">
              <el-badge
                v-if="thread.unreadCount > 0"
                :value="thread.unreadCount"
                :max="99"
                class="item"
              >
                <el-avatar size="medium" :src="thread.avatar"></el-avatar>
              </el-badge>
              <el-badge v-else-if="isUnreadThread(thread)" is-dot class="item">
                <el-avatar size="medium" :src="thread.avatar"></el-avatar>
              </el-badge>
              <el-avatar v-else size="medium" :src="thread.avatar"></el-avatar>
              <!-- <img v-if="thread.unreadCount === 0" class="avatar" width="40" height="40" :alt="thread.nickname"
                :src="thread.avatar" /> -->
            </div>
            <div class="list-right">
              <div class="top">
                <span class="nickname">{{ getThreadNickname(thread) }}</span>
                <span class="timestamp">
                  {{ thread.timestamp | time }}
                </span>
              </div>
              <div class="bottom">
                <span class="content">
                  <i
                    v-if="isNodisturbThread(thread)"
                    class="el-icon-remove-outline"
                  ></i>
                  <!-- <i v-if="isVisitorSend(thread)" class="el-icon-time"></i> -->
                  <span
                    v-if="getThreadDraft(thread).length > 0"
                    style="color: red;"
                    >[草稿]{{ getThreadDraft(thread) }}</span
                  >
                  {{ fromWorkGroup(thread) }}{{ showContent(thread) }}{{ fromClient(thread) }}
                  <!-- 标签，FIXME: 不能实时更新 -->
                  <p v-if="getUserCrmsTags(thread).length > 0">
                    <el-tag
                      size="mini"
                      v-for="tag in getUserCrmsTags(thread)"
                      :type="tag.colorType"
                      :key="tag.tid"
                      >{{ tag.name }}</el-tag
                    >
                  </p>
                </span>
              </div>
            </div>
          </li>
        </el-collapse-item>
        <!-- 星标会话 -->
        <el-collapse-item
          name="2" v-if="userStarThreads.length > 0"
        >
          <template slot="title">
            <div style="margin-left: 20px;">{{ collapseStarTitle }}</div>
          </template>
          <!-- 星标 -->
          <li
            v-for="thread in userStarThreads"
            :key="thread.tid"
            class="list-item"
            :class="{ ' active': thread.topic === userCurrentThread.topic }"
            @click.exact="selectThread(thread)"
            @click.right="rightEvent(thread)"
            @contextmenu="onStarContextmenu"
          >
            <div class="list-left">
              <el-badge
                v-if="thread.unreadCount > 0"
                :value="thread.unreadCount"
                :max="99"
                class="item"
              >
                <el-avatar size="medium" :src="thread.avatar"></el-avatar>
              </el-badge>
              <el-badge v-else-if="isUnreadThread(thread)" is-dot class="item">
                <el-avatar size="medium" :src="thread.avatar"></el-avatar>
              </el-badge>
              <el-avatar v-else size="medium" :src="thread.avatar"></el-avatar>
              <!-- <img v-if="thread.unreadCount === 0" class="avatar" width="40" height="40" :alt="thread.nickname"
                :src="thread.avatar" /> -->
            </div>
            <div class="list-right">
              <div class="top">
                <span class="nickname">{{ getThreadNickname(thread) }}</span>
                <span class="timestamp">
                  {{ thread.timestamp | time }}
                </span>
              </div>
              <div class="bottom">
                <span class="content">
                  <i
                    v-if="isNodisturbThread(thread)"
                    class="el-icon-remove-outline"
                  ></i>
                  <!-- <i v-if="isVisitorSend(thread)" class="el-icon-time"></i> -->
                  <span
                    v-if="getThreadDraft(thread).length > 0"
                    style="color: red;"
                    >[草稿]{{ getThreadDraft(thread) }}</span
                  >
                  {{ fromWorkGroup(thread) }}{{ showContent(thread) }}{{ fromClient(thread) }}
                  <!-- 标签，FIXME: 不能实时更新 -->
                  <p v-if="getUserCrmsTags(thread).length > 0">
                    <el-tag
                      size="mini"
                      v-for="tag in getUserCrmsTags(thread)"
                      :type="tag.colorType"
                      :key="tag.tid"
                      >{{ tag.name }}</el-tag
                    >
                  </p>
                </span>
                <span class="star">
                  <i v-if="thread.starType === 1" class="el-icon-star-on menu-star-red"></i>
                  <i v-if="thread.starType === 2" class="el-icon-star-on menu-star-yellow"></i>
                  <i v-if="thread.starType === 3" class="el-icon-star-on menu-star-blue"></i>
                  <i v-if="thread.starType === 4" class="el-icon-star-on menu-star-green"></i>
                </span>
              </div>
            </div>
          </li>
        </el-collapse-item>
        <!-- 进行中客服会话 -->
        <el-collapse-item name="3">
          <template slot="title">
            <div style="margin-left: 20px;">{{ collapseCurrentTitle }}</div>
          </template>
          <li
            v-for="thread in filterdThreads"
            :key="thread.tid"
            class="list-item"
            :class="{ ' active': thread.topic === userCurrentThread.topic }"
            @click.exact="selectThread(thread)"
            @click.right="rightEvent(thread)"
            @contextmenu.prevent="onContextmenu"
          >
            <div class="list-left">
              <el-badge
                v-if="thread.unreadCount > 0"
                :value="thread.unreadCount"
                :max="99"
                class="item"
              >
                <el-avatar size="medium" :src="thread.avatar"></el-avatar>
              </el-badge>
              <el-badge v-else-if="isUnreadThread(thread)" is-dot class="item">
                <el-avatar size="medium" :src="thread.avatar"></el-avatar>
              </el-badge>
              <el-avatar v-else size="medium" :src="thread.avatar"></el-avatar>
              <!-- <img v-else-if="thread.unreadCount === 0" class="avatar" width="40" height="40" :alt="thread.nickname"
                :src="thread.avatar" /> -->
            </div>
            <div class="list-right">
              <div class="top">
                <span class="nickname">
                  {{ getThreadNickname(thread) }}
                  <i
                    v-if="isNodisturbThread(thread)"
                    class="el-icon-remove-outline"
                  ></i>
                </span>
                <span class="timestamp">
                  {{ thread.timestamp | time }}
                </span>
              </div>
              <div class="bottom">
                <span class="content">
                  <span
                    style="color:red;"
                    v-if="
                      showOutOfTime &&
                        isTypeThread(thread) &&
                        threadWillOutOfTime(thread)
                    "
                    >{{ $t("willOutOfTime") + (30 - thread.delay) }}</span
                  >
                  <span
                    style="color:red;"
                    v-if="
                      showOutOfTime &&
                        isTypeThread(thread) &&
                        threadOutOfTime(thread)
                    "
                    >{{ $t("OutOfTime") }}</span
                  >
                  <i
                    v-if="isNodisturbThread(thread)"
                    class="el-icon-remove-outline"
                  ></i>
                  <!-- <i v-if="isVisitorSend(thread)" class="el-icon-time"></i> -->
                  <span
                    v-if="getThreadDraft(thread).length > 0"
                    style="color: red;"
                    >[草稿]{{ getThreadDraft(thread) }}</span
                  >
                  {{ fromWorkGroup(thread) }}{{ showContent(thread) }}{{ fromClient(thread) }}
                  <!-- 标签，FIXME: 不能实时更新 -->
                  <p v-if="getUserCrmsTags(thread).length > 0">
                    <el-tag
                      size="mini"
                      v-for="tag in getUserCrmsTags(thread)"
                      :type="tag.colorType"
                      :key="tag.tid"
                      >{{ tag.name }}</el-tag
                    >
                  </p>
                </span>
              </div>
              <!-- <div class="tag">
                <el-tag size="small">{{ thread.client }}</el-tag>
              </div> -->
            </div>
          </li>
        </el-collapse-item>
        <!-- 工单 -->
        <!-- <el-collapse-item name="4" v-if="ticketThreads.length > 0">
          <template slot="title">
            <div style="margin-left: 20px;">{{ collapseTicketTitle }}</div>
          </template>
          <li
            v-for="thread in ticketThreads"
            :key="thread.topic"
            class="list-item"
            :class="{ ' active': thread.topic === userCurrentThread.topic }"
            @click.exact="selectThread(thread)"
            @click.right="rightEvent(thread)"
            @contextmenu.prevent="onContextmenu"
          >
            <div class="list-right-ticket">
              <div class="top">
                <span class="nickname">
                  {{ thread.ticketTitle }}
                  <i
                    v-if="isNodisturbThread(thread)"
                    class="el-icon-remove-outline"
                  ></i>
                </span>
                <span class="timestamp">
                  {{ thread.timestamp | time }}
                </span>
              </div>
              <div class="bottom">
                <span class="content" v-html="thread.content"></span>
              </div>
            </div>
          </li>
        </el-collapse-item> -->
        <!-- 同事会话 -->
        <el-collapse-item name="5" v-if="contactThreads.length > 0">
          <template slot="title">
            <div style="margin-left: 20px;">{{ collapseContactTitle }}</div>
          </template>
          <li
            v-for="thread in contactThreads"
            :key="thread.topic"
            class="list-item"
            :class="{ ' active': thread.topic === userCurrentThread.topic }"
            @click.exact="selectThread(thread)"
            @click.right="rightEvent(thread)"
            @contextmenu.prevent="onContextmenu"
          >
            <div class="list-left">
              <el-badge
                v-if="thread.unreadCount > 0"
                :value="thread.unreadCount"
                :max="99"
                class="item"
              >
                <el-avatar size="medium" :src="thread.avatar"></el-avatar>
              </el-badge>
              <el-badge v-else-if="isUnreadThread(thread)" is-dot class="item">
                <el-avatar size="medium" :src="thread.avatar"></el-avatar>
              </el-badge>
              <el-avatar v-else size="medium" :src="thread.avatar"></el-avatar>
              <!-- <img v-if="thread.unreadCount === 0" class="avatar" width="40" height="40" :alt="thread.nickname"
                :src="thread.avatar" /> -->
            </div>
            <div class="list-right">
              <div class="top">
                <span class="nickname">
                  {{ getThreadNickname(thread) }}
                  <i
                    v-if="isNodisturbThread(thread)"
                    class="el-icon-remove-outline"
                  ></i>
                </span>
                <span class="timestamp">
                  {{ thread.timestamp | time }}
                </span>
              </div>
              <div class="bottom">
                <span class="content">
                  {{ showContent(thread) }}
                </span>
              </div>
            </div>
          </li>
        </el-collapse-item>
        <!-- 群组会话 -->
        <el-collapse-item name="6" v-if="groupThreads.length > 0">
          <template slot="title">
            <div style="margin-left: 20px;">{{ collapseGroupTitle }}</div>
          </template>
          <li
            v-for="thread in groupThreads"
            :key="thread.topic"
            class="list-item"
            :class="{ ' active': thread.topic === userCurrentThread.topic }"
            @click.exact="selectThread(thread)"
            @click.right="rightEvent(thread)"
            @contextmenu.prevent="onContextmenu"
          >
            <div class="list-left">
              <el-badge
                v-if="thread.unreadCount > 0"
                :value="thread.unreadCount"
                :max="99"
                class="item"
              >
                <el-avatar size="medium" :src="thread.avatar"></el-avatar>
              </el-badge>
              <el-badge v-else-if="isUnreadThread(thread)" is-dot class="item">
                <el-avatar size="medium" :src="thread.avatar"></el-avatar>
              </el-badge>
              <el-avatar v-else size="medium" :src="thread.avatar"></el-avatar>
              <!-- <img v-if="thread.unreadCount === 0" class="avatar" width="40" height="40" :alt="thread.nickname"
                :src="thread.avatar" /> -->
            </div>
            <div class="list-right">
              <div class="top">
                <span class="nickname">
                  {{ getThreadNickname(thread) }}
                  <i
                    v-if="isNodisturbThread(thread)"
                    class="el-icon-remove-outline"
                  ></i>
                </span>
                <span class="timestamp">
                  {{ thread.timestamp | time }}
                </span>
              </div>
              <div class="bottom">
                <span class="content">
                  {{ showContent(thread) }}
                </span>
              </div>
            </div>
          </li>
        </el-collapse-item>
        <!-- 历史会话列表 - 右键可重新开启会话 -->
        <el-collapse-item name="7">
          <template slot="title">
            <div style="margin-left: 20px;">{{ collapseHistoryTitle }}</div>
          </template>
          <li
            v-for="thread in historyRecords"
            :key="thread.tid"
            class="list-item"
            :class="{ ' active': thread.tid === userCurrentThread.tid }"
            @click.exact="selectThread(thread)"
            @click.right="rightEvent(thread)"
            @contextmenu="onHistoryContextmenu"
          >
            <div class="list-left">
              <el-badge
                v-if="thread.unreadCount > 0"
                :value="thread.unreadCount"
                :max="99"
                class="item"
              >
                <el-avatar size="medium" :src="thread.avatar"></el-avatar>
              </el-badge>
              <el-badge v-else-if="isUnreadThread(thread)" is-dot class="item">
                <el-avatar size="medium" :src="thread.avatar"></el-avatar>
              </el-badge>
              <el-avatar v-else size="medium" :src="thread.avatar"></el-avatar>
              <!-- <img v-if="thread.unreadCount === 0" class="avatar" width="40" height="40" :alt="thread.nickname"
                :src="thread.avatar" /> -->
            </div>
            <div class="list-right">
              <div class="top">
                <span class="nickname">{{ getThreadNickname(thread) }}</span>
                <span class="timestamp">
                  {{ thread.timestamp | time }}
                </span>
              </div>
              <div class="bottom">
                <span class="content">
                  <!-- 免打扰 -->
                  <i
                    v-if="isNodisturbThread(thread)"
                    class="el-icon-remove-outline"
                  ></i>
                  <!-- 草稿 -->
                  <span
                    v-if="getThreadDraft(thread).length > 0"
                    style="color: red;"
                    >[草稿]{{ getThreadDraft(thread) }}</span
                  >
                  {{ fromWorkGroup(thread) }}{{ showContent(thread) }}{{ fromClient(thread) }}
                  <!-- 标签，FIXME: 不能实时更新 -->
                  <p v-if="getUserCrmsTags(thread).length > 0">
                    <el-tag
                      size="mini"
                      v-for="tag in getUserCrmsTags(thread)"
                      :type="tag.colorType"
                      :key="tag.tid"
                      >{{ tag.name }}</el-tag
                    >
                  </p>
                </span>
              </div>
            </div>
          </li>
          <el-empty
            v-if="historyRecordsThreads.content.length === 0"
            description="无会话"
          ></el-empty>
          <el-button
            v-if="canLoadMoreThread && showUniqueHistory"
            type="text"
            @click="loadMoreThread"
            >{{ $t("more") }} </el-button
          ><br />
          <el-pagination
            v-if="!showUniqueHistory"
            :page-size="pageSize"
            :pager-count="5"
            :current-page="currentPage"
            @current-change="handleCurrentChange"
            :page-count="historyRecordsThreads.totalPages"
            :total="historyRecordsThreads.totalElements"
            :hide-on-single-page="true"
            layout="prev, pager, next"
          >
          </el-pagination>
          <el-switch
            v-model="showUniqueHistory"
            :active-text="unduplicateTip"
          ></el-switch>
        </el-collapse-item>
      </el-collapse>
    </div>
    <!-- <audio id="audioPlay" :src="soundUrl" hidden="true" /> -->
    <!-- 此右键菜单专门用于electron, 因为web版的onClick无法触发 -->
    <!-- https://github.com/chiic/vue-contextmenu -->
    <vue-context-menu
      :contextMenuData="topContextMenuData"
      @HandlerUnmarkThreadTop="Handler_unmarkThreadTop()"
      @HandlerUnreadThread="Handler_unreadThread()"
      @HandlerBlock="Handler_Block()"
      @HandlerNodisturbThread="Handler_NodisturbThread()"
      @HandlerUpdateNoteThread="Handler_updateNoteThread()"
      @HandlerCrm="Handler_crm()"
      @HandlerTickets="Handler_tickets()"
      @HandlerTransfer="Handler_transfer()"
      @HandlerSummary="Handler_summary()"
      @HandlerClose="Handler_close()"
    ></vue-context-menu>
    <vue-context-menu
      :contextMenuData="starContextMenuData"
      @HandlerMarkThreadStar0="Handler_markThreadStar0()"
      @HandlerUnreadThread="Handler_unreadThread()"
      @HandlerBlock="Handler_Block()"
      @HandlerNodisturbThread="Handler_NodisturbThread()"
      @HandlerUpdateNoteThread="Handler_updateNoteThread()"
      @HandlerCrm="Handler_crm()"
      @HandlerTickets="Handler_tickets()"
      @HandlerTransfer="Handler_transfer()"
      @HandlerSummary="Handler_summary()"
      @HandlerClose="Handler_close()"
    ></vue-context-menu>
    <vue-context-menu
      :contextMenuData="currentContextMenuData"
      @HandlerMarkThreadTop="Handler_markThreadTop()"
      @HandlerUnreadThread="Handler_unreadThread()"
      @HandlerMarkThreadStar1="Handler_markThreadStar1()"
      @HandlerMarkThreadStar2="Handler_markThreadStar2()"
      @HandlerMarkThreadStar3="Handler_markThreadStar3()"
      @HandlerMarkThreadStar4="Handler_markThreadStar4()"
      @HandlerNodisturbThread="Handler_NodisturbThread()"
      @HandlerBlock="Handler_Block()"
      @HandlerRestartThread="Handler_restartThread()"
      @HandlerUpdateNoteThread="Handler_updateNoteThread()"
      @HandlerCrm="Handler_crm()"
      @HandlerTickets="Handler_tickets()"
      @HandlerTransfer="Handler_transfer()"
      @HandlerSummary="Handler_summary()"
      @HandlerClose="Handler_close()"
    ></vue-context-menu>
    <vue-context-menu
      :contextMenuData="historyContextMenuData"
      @HandlerMarkThreadTop="Handler_markThreadTop()"
      @HandlerUnreadThread="Handler_unreadThread()"
      @HandlerMarkThreadStar1="Handler_markThreadStar1()"
      @HandlerMarkThreadStar2="Handler_markThreadStar2()"
      @HandlerMarkThreadStar3="Handler_markThreadStar3()"
      @HandlerMarkThreadStar4="Handler_markThreadStar4()"
      @HandlerBlock="Handler_Block()"
      @HandlerNodisturbThread="Handler_NodisturbThread()"
      @HandlerRestartThread="Handler_restartThread()"
      @HandlerUpdateNoteThread="Handler_updateNoteThread()"
      @HandlerCrm="Handler_crm()"
      @HandlerTickets="Handler_tickets()"
      @HandlerTransfer="Handler_transfer()"
      @HandlerSummary="Handler_summary()"
      @HandlerClose="Handler_close()"
    ></vue-context-menu>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
const constants = require("@/util/constants");
import bus from "@/util/eventbus";
// import * as https from "@/apis/http";
// import Vue from "vue";
// http://static.kancloud.cn/wangjiachong/gongzuopian/1238637
// import { component as VueContextMenu } from '@xunlei/vue-context-menu'

export default {
  name: "bd-aside",
  data() {
    return {
      search: "",
      // soundUrl: constants.SOUND_DINGDONG_URL,
      activeNames: ["1", "2", "3"],
      rightSelectThread: "",
      //
      currentPage: 1,
      pageSize: 20,
      loadingMoreThread: false,
      // 去重
      showUniqueHistory: true,
      //
      timer: "",
      refreshTimer: "",
      //
      electron: constants.IS_ELECTRON,
      contextMenuTarget: document.body, // 可右键区域，这里也可以绑定$refs
      contextMenuVisible: false,
      // transferIndex: null, // Show the menu that was clicked
      topContextMenuData: {
        menuName: "topContextMenu",
        axis: {
          x: null,
          y: null,
        },
        menulists: [
          {
            btnName: this.$t("notop"),
            icoName: "el-icon-bottom",
            fnHandler: "HandlerUnmarkThreadTop",
          },
          {
            btnName: this.$t("updateNote"),
            icoName: "el-icon-edit",
            fnHandler: "HandlerUpdateNoteThread",
          },
          {
            btnName: this.$t("block"),
            icoName: "iconfont icon-block",
            fnHandler: "HandlerBlock",
          },
          {
            btnName: this.$t("crm"),
            icoName: "el-icon-circle-plus-outline",
            fnHandler: "HandlerCrm",
          },
          {
            btnName: this.$t("tickets"),
            icoName: "el-icon-tickets",
            fnHandler: "HandlerTickets",
          },
          {
            btnName: this.$t("transfer"),
            icoName: "el-icon-refresh",
            fnHandler: "HandlerTransfer",
          },
          {
            btnName: this.$t("summary"),
            icoName: "el-icon-document-checked",
            fnHandler: "HandlerSummary",
          },
          {
            btnName: this.$t("close"),
            icoName: "el-icon-close",
            fnHandler: "HandlerClose",
          },
        ],
      },
      starContextMenuData: {
        menuName: "starContextMenu",
        axis: {
          x: null,
          y: null,
        },
        menulists: [
          {
            btnName: this.$t("starCancel"),
            icoName: "el-icon-star-off",
            fnHandler: "HandlerMarkThreadStar0",
          },
          {
            btnName: this.$t("updateNote"),
            icoName: "el-icon-edit",
            fnHandler: "HandlerUpdateNoteThread",
          },
          {
            btnName: this.$t("block"),
            icoName: "iconfont icon-block",
            fnHandler: "HandlerBlock",
          },
          {
            btnName: this.$t("crm"),
            icoName: "el-icon-circle-plus-outline",
            fnHandler: "HandlerCrm",
          },
          {
            btnName: this.$t("tickets"),
            icoName: "el-icon-tickets",
            fnHandler: "HandlerTickets",
          },
          {
            btnName: this.$t("transfer"),
            icoName: "el-icon-refresh",
            fnHandler: "HandlerTransfer",
          },
          {
            btnName: this.$t("summary"),
            icoName: "el-icon-document-checked",
            fnHandler: "HandlerSummary",
          },
          {
            btnName: this.$t("close"),
            icoName: "el-icon-close",
            fnHandler: "HandlerClose",
          },
        ],
      },
      currentContextMenuData: {
        menuName: "currentContextMenu",
        axis: {
          x: null,
          y: null,
        },
        menulists: [
          {
            btnName: this.$t("top"),
            icoName: "el-icon-top",
            fnHandler: "HandlerMarkThreadTop",
          },
          {
            btnName: this.$t("starSet"),
            icoName: "el-icon-star-off",
            children: [
              {
                btnName: this.$t("star1"),
                icoName: "el-icon-star-on menu-star-red",
                fnHandler: "HandlerMarkThreadStar1",
              },
              {
                btnName: this.$t("star2"),
                icoName: "el-icon-star-on menu-star-yellow",
                fnHandler: "HandlerMarkThreadStar2",
              },
              {
                btnName: this.$t("star3"),
                icoName: "el-icon-star-on menu-star-blue",
                fnHandler: "HandlerMarkThreadStar3",
              },
              {
                btnName: this.$t("star4"),
                icoName: "el-icon-star-on menu-star-green",
                fnHandler: "HandlerMarkThreadStar4",
              },
            ],
          },
          {
            btnName: this.$t("updateNote"),
            icoName: "el-icon-edit",
            fnHandler: "HandlerUpdateNoteThread",
          },
          // {
          //   btnName: this.$t("closeThread"),
          //   icoName: "el-icon-close",
          //   fnHandler: "HandlerCloseThread",
          // },
          // 有bug，暂时不用
          // {
          //   btnName: this.isNodisturbThread(this.rightSelectThread)
          //     ? this.$t("unnodisturb")
          //     : this.$t("nodisturb"),
          //   icoName:"el-icon-remove-outline",
          //   fnHandler: "HandlerNodisturbThread"
          // },
          {
            btnName: this.$t("block"),
            icoName: "iconfont icon-block",
            fnHandler: "HandlerBlock",
          },
          {
            btnName: this.$t("crm"),
            icoName: "el-icon-circle-plus-outline",
            fnHandler: "HandlerCrm",
          },
          {
            btnName: this.$t("tickets"),
            icoName: "el-icon-tickets",
            fnHandler: "HandlerTickets",
          },
          {
            btnName: this.$t("transfer"),
            icoName: "el-icon-refresh",
            fnHandler: "HandlerTransfer",
          },
          {
            btnName: this.$t("summary"),
            icoName: "el-icon-document-checked",
            fnHandler: "HandlerSummary",
          },
          {
            btnName: this.$t("close"),
            icoName: "el-icon-close",
            fnHandler: "HandlerClose",
          },
        ],
      },
      historyContextMenuData: {
        menuName: "historyContextMenu",
        axis: {
          x: null,
          y: null,
        },
        menulists: [
          {
            btnName: this.$t("top"),
            icoName: "el-icon-top",
            fnHandler: "HandlerMarkThreadTop",
          },
          {
            btnName: this.$t("starSet"),
            icoName: "el-icon-star-off",
            children: [
              {
                btnName: this.$t("star1"),
                icoName: "el-icon-star-on menu-star-red",
                fnHandler: "HandlerMarkThreadStar1",
              },
              {
                btnName: this.$t("star2"),
                icoName: "el-icon-star-on menu-star-yellow",
                fnHandler: "HandlerMarkThreadStar2",
              },
              {
                btnName: this.$t("star3"),
                icoName: "el-icon-star-on menu-star-blue",
                fnHandler: "HandlerMarkThreadStar3",
              },
              {
                btnName: this.$t("star4"),
                icoName: "el-icon-star-on menu-star-green",
                fnHandler: "HandlerMarkThreadStar4",
              },
            ],
          },
          {
            btnName: this.$t("updateNote"),
            icoName: "el-icon-edit",
            fnHandler: "HandlerUpdateNoteThread",
          },
          {
            btnName: this.$t("block"),
            icoName: "iconfont icon-block",
            fnHandler: "HandlerBlock",
          },
          {
            btnName: this.$t("restartChat"),
            icoName: "el-icon-chat-round",
            fnHandler: "HandlerRestartThread",
          },
          {
            btnName: this.$t("crm"),
            icoName: "el-icon-circle-plus-outline",
            fnHandler: "HandlerCrm",
          },
          {
            btnName: this.$t("tickets"),
            icoName: "el-icon-tickets",
            fnHandler: "HandlerTickets",
          },
          {
            btnName: this.$t("transfer"),
            icoName: "el-icon-refresh",
            fnHandler: "HandlerTransfer",
          },
          {
            btnName: this.$t("summary"),
            icoName: "el-icon-document-checked",
            fnHandler: "HandlerSummary",
          },
          // {
          //   btnName: this.$t("close"),
          //   icoName: "el-icon-circle-plus-outline",
          //   fnHandler: "HandlerClose",
          // },
        ],
      },
    };
  },
  // components: { VueContextMenu },
  computed: {
    ...mapGetters([
      "userInfo",
      "userThreads",
      "userCurrentThread",
      "userContacts",
      "historyRecordsThreads",
      "showAuthority",
      "showOutOfTime",
      "connectionStatus",
      "userTopThreads",
      "userStarThreads",
      "userNodisturbThreadTopics",
      "userUnreadThreadTopics",
      "channelThreads",
      "ticketThreads",
      "contactThreads",
      "groupThreads",
      "networkConnected",
      "isPullingUnreadMessage",
      "userDrafts",
      "userCrms",
      "workGroups"
    ]),
    filterdThreads() {
      return this.userThreads.filter((thread) => {
        if (thread.nickname != null && thread.content != null) {
          return (
            thread.nickname.includes(this.search) ||
            thread.content.includes(this.search)
          );
        } else if (thread.nickname != null) {
          return thread.nickname.includes(this.search);
        } else if (thread.content != null) {
          return thread.content.includes(this.search);
        }
      });
    },
    // 过滤
    uniqueHistoryRecords() {
      let unique = [];
      for (let i = 0; i < this.historyRecordsThreads.content.length; i++) {
        const thread = this.historyRecordsThreads.content[i];
        let contains = unique.some((trd) => {
          // return trd.uid === thread.uid;
          return trd.topic === thread.topic;
        });
        // 过滤掉工单会话
        if (!contains && thread.type !== constants.THREAD_TYPE_TICKET_APPOINTED && thread.type !== constants.THREAD_TYPE_TICKET_WORKGROUP) {
          unique.push(thread);
        }
      }
      return unique;
    },
    historyRecords() {
      if (this.showUniqueHistory) {
        return this.uniqueHistoryRecords;
      } else {
        return this.historyRecordsThreads.content.filter(thread => {
          // 过滤掉工单会话
          return thread.type !== constants.THREAD_TYPE_TICKET_APPOINTED && thread.type !== constants.THREAD_TYPE_TICKET_WORKGROUP
        });
      }
    },
    searchTip() {
      return this.$t("search");
    },
    refreshThreadsTip() {
      return this.$t("refreshThreads");
    },
    collapseChannelTitle() {
      return this.$t("channelNotice") + " (" + this.channelThreads.length + ")";
    },
    collapseTopTitle() {
      return this.$t("top") + " (" + this.userTopThreads.length + ")";
    },
    collapseStarTitle() {
      return (
        this.$t("starThread") +
        " (" +
        this.userStarThreads.length +
        ")"
      );
    },
    collapseTicketTitle() {
      return this.$t("ticketThreads") + " (" + this.ticketThreads.length + ")";
    },
    collapseContactTitle() {
      return (
        this.$t("contactThreads") + " (" + this.contactThreads.length + ")"
      );
    },
    collapseGroupTitle() {
      return this.$t("groupThreads") + " (" + this.groupThreads.length + ")";
    },
    collapseCurrentTitle() {
      return this.$t("processing") + " (" + this.filterdThreads.length + ")";
    },
    collapseHistoryTitle() {
      return this.$t("closed"); // + " (" + this.uniqueHistoryRecords.length + ")";
    },
    canLoadMoreThread() {
      if (this.currentPage <= 1) {
        return true;
      }
      return !this.historyRecordsThreads.last;
    },
    // loadMoreThreadDisabled() {
    //   return this.currentPage > 2 && this.historyRecordsThreads.last;
    // },
    unduplicateTip() {
      return this.$t("unduplicate");
    },
    networkErrorTip() {
      return this.$t("networkError");
    },
    pullingMessageTip() {
      return this.$t("pullingMessage");
    },
    tagTip() {
      return this.$t("tag");
    },
    // getUserCrmsTags(thread) {
    //   //
    //   let tags = []
    //   let uid = thread.topic.split('/')[1]
    //   for (let i = 0; i < this.userCrms.length; i++) {
    //     const element = this.userCrms[i]
    //     // console.log('user crm:', element)
    //     if (element.uid === uid) {
    //       tags = element.tags
    //     }
    //   }
    //   return tags
    // },
  },
  methods: {
    ...mapActions([
      "getThreads",
      "getThreadHistoryRecords",
      "getChannelThread",
      "getTicketThread",
      "updateCurrentThread",
      "restartThread",
      "updateContact",
      "updateGroup",
      "createGroup",
      "markThreadDeleted",
      "unmarkThreadDeleted",
      "updateThreadDelay",
      "markThreadNodisturb",
      "unmarkThreadNodisturb",
      "markThreadUnread",
      "unmarkThreadUnread",
      "searchHistoryThread",
      "searchMessageArchive",
      "getUnreadMessagesAgent",
      "getTopThreads",
      "markThreadTop",
      "unmarkThreadTop",
      "getStarThreads",
      "markThreadStar",
      "updateNote",
      "getCustomerInfoByUid",
      "getWorkGroups"
    ]),
    getThreadNickname(thread) {
      if (thread.topic.startsWith('filehelper')) {
        return this.$t('fileHelper')
      }
      return thread.nickname
    },
    getThreadDraft(thread) {
      for (let i = 0; i < this.userDrafts.length; i++) {
        let element = this.userDrafts[i];
        if (element.key === thread.topic) {
          return element.value;
        }
      }
      return "";
    },
    getUserCrmsTags(thread) {
      let uid = thread.topic.split("/")[1];
      for (let i = 0; i < this.userCrms.length; i++) {
        const element = this.userCrms[i];
        if (element.uid === uid) {
          return element.tags;
        }
      }
      return [];
    },
    showTopContextMenu() {
      // this.transferIndex = index; // transfer index to child component
      event.preventDefault();
      var x = event.clientX;
      var y = event.clientY;
      //
      let containsNodisturb = false;
      let contaisnUnread = false;
      // 动态添加免打扰 和 未读
      for (var i = 0; i < this.topContextMenuData.menulists.length; i++) {
        var menu = this.topContextMenuData.menulists[i];
        if (menu.fnHandler === "HandlerNodisturbThread") {
          containsNodisturb = true;
          if (this.isNodisturbThread(this.rightSelectThread)) {
            this.topContextMenuData.menulists[i].btnName = this.$t(
              "unnodisturb"
            );
          } else {
            this.topContextMenuData.menulists[i].btnName = this.$t("nodisturb");
          }
        }
        if (menu.fnHandler === "HandlerUnreadThread") {
          contaisnUnread = true;
          if (this.isUnreadThread(this.rightSelectThread)) {
            this.topContextMenuData.menulists[i].btnName = this.$t("nounread");
          } else {
            this.topContextMenuData.menulists[i].btnName = this.$t("unread");
          }
        }
      }
      if (!contaisnUnread) {
        // 插入免打扰菜单
        this.topContextMenuData.menulists.push({
          btnName: this.isNodisturbThread(this.rightSelectThread)
            ? this.$t("unnodisturb")
            : this.$t("nodisturb"),
          icoName: "el-icon-remove-outline",
          fnHandler: "HandlerNodisturbThread",
        });
      }
      if (!containsNodisturb) {
        // 插入未读菜单
        this.topContextMenuData.menulists.push({
          btnName: this.isUnreadThread(this.rightSelectThread)
            ? this.$t("nounread")
            : this.$t("unread"),
          icoName: "el-icon-news",
          fnHandler: "HandlerUnreadThread",
        });
      }
      this.topContextMenuData.axis = {
        x,
        y,
      };
    },
    showStarContextMenu() {
      // this.transferIndex = index; // transfer index to child component
      event.preventDefault();
      var x = event.clientX;
      var y = event.clientY;
      //
      let containsNodisturb = false;
      let contaisnUnread = false;
      // 动态添加免打扰 和 未读
      for (var i = 0; i < this.starContextMenuData.menulists.length; i++) {
        var menu = this.starContextMenuData.menulists[i];
        if (menu.fnHandler === "HandlerNodisturbThread") {
          containsNodisturb = true;
          if (this.isNodisturbThread(this.rightSelectThread)) {
            this.starContextMenuData.menulists[i].btnName = this.$t(
              "unnodisturb"
            );
          } else {
            this.starContextMenuData.menulists[i].btnName = this.$t(
              "nodisturb"
            );
          }
        }
        if (menu.fnHandler === "HandlerUnreadThread") {
          contaisnUnread = true;
          if (this.isUnreadThread(this.rightSelectThread)) {
            this.starContextMenuData.menulists[i].btnName = this.$t("nounread");
          } else {
            this.starContextMenuData.menulists[i].btnName = this.$t("unread");
          }
        }
      }
      if (!contaisnUnread) {
        // 插入免打扰菜单
        this.starContextMenuData.menulists.push({
          btnName: this.isNodisturbThread(this.rightSelectThread)
            ? this.$t("unnodisturb")
            : this.$t("nodisturb"),
          icoName: "el-icon-remove-outline",
          fnHandler: "HandlerNodisturbThread",
        });
      }
      if (!containsNodisturb) {
        // 插入未读菜单
        this.starContextMenuData.menulists.push({
          btnName: this.isUnreadThread(this.rightSelectThread)
            ? this.$t("nounread")
            : this.$t("unread"),
          icoName: "el-icon-news",
          fnHandler: "HandlerUnreadThread",
        });
      }
      this.starContextMenuData.axis = {
        x,
        y,
      };
    },
    showCurrentContextMenu() {
      // this.transferIndex = index; // transfer index to child component
      event.preventDefault();
      var x = event.clientX;
      var y = event.clientY;
      //
      let containsNodisturb = false;
      let contaisnUnread = false;
      // 动态添加免打扰 和 未读
      for (var i = 0; i < this.currentContextMenuData.menulists.length; i++) {
        var menu = this.currentContextMenuData.menulists[i];
        if (menu.fnHandler === "HandlerNodisturbThread") {
          containsNodisturb = true;
          if (this.isNodisturbThread(this.rightSelectThread)) {
            this.currentContextMenuData.menulists[i].btnName = this.$t(
              "unnodisturb"
            );
          } else {
            this.currentContextMenuData.menulists[i].btnName = this.$t(
              "nodisturb"
            );
          }
        }
        if (menu.fnHandler === "HandlerUnreadThread") {
          contaisnUnread = true;
          if (this.isUnreadThread(this.rightSelectThread)) {
            this.currentContextMenuData.menulists[i].btnName = this.$t(
              "nounread"
            );
          } else {
            this.currentContextMenuData.menulists[i].btnName = this.$t(
              "unread"
            );
          }
        }
      }
      if (!contaisnUnread) {
        // 插入免打扰菜单
        this.currentContextMenuData.menulists.push({
          btnName: this.isNodisturbThread(this.rightSelectThread)
            ? this.$t("unnodisturb")
            : this.$t("nodisturb"),
          icoName: "el-icon-remove-outline",
          fnHandler: "HandlerNodisturbThread",
        });
      }
      if (!containsNodisturb) {
        // 插入未读菜单
        this.currentContextMenuData.menulists.push({
          btnName: this.isUnreadThread(this.rightSelectThread)
            ? this.$t("nounread")
            : this.$t("unread"),
          icoName: "el-icon-news",
          fnHandler: "HandlerUnreadThread",
        });
      }
      this.currentContextMenuData.axis = {
        x,
        y,
      };
    },
    showHistoryContextMenu() {
      // this.transferIndex = index; // transfer index to child component
      event.preventDefault();
      var x = event.clientX;
      var y = event.clientY;
      //
      let containsNodisturb = false;
      let contaisnUnread = false;
      // 动态添加免打扰 和 未读
      for (var i = 0; i < this.historyContextMenuData.menulists.length; i++) {
        var menu = this.historyContextMenuData.menulists[i];
        if (menu.fnHandler === "HandlerNodisturbThread") {
          containsNodisturb = true;
          if (this.isNodisturbThread(this.rightSelectThread)) {
            this.historyContextMenuData.menulists[i].btnName = this.$t(
              "unnodisturb"
            );
          } else {
            this.historyContextMenuData.menulists[i].btnName = this.$t(
              "nodisturb"
            );
          }
        }
        if (menu.fnHandler === "HandlerUnreadThread") {
          contaisnUnread = true;
          if (this.isUnreadThread(this.rightSelectThread)) {
            this.historyContextMenuData.menulists[i].btnName = this.$t(
              "nounread"
            );
          } else {
            this.historyContextMenuData.menulists[i].btnName = this.$t(
              "unread"
            );
          }
        }
      }
      if (!contaisnUnread) {
        // 插入免打扰菜单
        this.historyContextMenuData.menulists.push({
          btnName: this.isNodisturbThread(this.rightSelectThread)
            ? this.$t("unnodisturb")
            : this.$t("nodisturb"),
          icoName: "el-icon-remove-outline",
          fnHandler: "HandlerNodisturbThread",
        });
      }
      if (!containsNodisturb) {
        // 插入未读菜单
        this.historyContextMenuData.menulists.push({
          btnName: this.isUnreadThread(this.rightSelectThread)
            ? this.$t("nounread")
            : this.$t("unread"),
          icoName: "el-icon-news",
          fnHandler: "HandlerUnreadThread",
        });
      }
      this.historyContextMenuData.axis = {
        x,
        y,
      };
    },
    Handler_markThreadTop() {
      // console.log('选项1-1-1绑定事件执行');
      // 置顶会话
      this.markThreadTop(this.rightSelectThread);
    },
    Handler_unmarkThreadTop() {
      // 取消置顶会话
      this.unmarkThreadTop(this.rightSelectThread);
    },
    Handler_unreadThread() {
      if (this.isUnreadThread(this.rightSelectThread)) {
        // console.log('取消未读')
        this.unmarkThreadUnread(this.rightSelectThread);
      } else {
        // console.log('标记未读')
        this.markThreadUnread(this.rightSelectThread);
      }
    },
    Handler_markThreadStar0() {
      // 取消星标
      let payload = { thread: this.rightSelectThread, starType: 0 };
      this.markThreadStar(payload);
    },
    Handler_markThreadStar1() {
      // 星标1
      let payload = { thread: this.rightSelectThread, starType: 1 };
      this.markThreadStar(payload);
    },
    Handler_markThreadStar2() {
      // 星标1
      let payload = { thread: this.rightSelectThread, starType: 2 };
      this.markThreadStar(payload);
    },
    Handler_markThreadStar3() {
      // 星标1
      let payload = { thread: this.rightSelectThread, starType: 3 };
      this.markThreadStar(payload);
    },
    Handler_markThreadStar4() {
      // 星标1
      let payload = { thread: this.rightSelectThread, starType: 4 };
      this.markThreadStar(payload);
    },
    Handler_updateNoteThread() {
      // 设置备注
      this.threadUpdateNote();
    },
    // @HandlerCloseThread="Handler_CloseThread()"
    // Handler_CloseThread() {
    //   // 结束会话
    //   bus.$emit(
    //     constants.EVENT_BUS_THREAD_AGENT_CLOSE,
    //     this.rightSelectThread.tid
    //   );
    // },
    Handler_NodisturbThread() {
      if (this.isNodisturbThread(this.rightSelectThread)) {
        // console.log('取消免打扰')
        this.unmarkThreadNodisturb(this.rightSelectThread);
      } else {
        // console.log('免打扰')
        this.markThreadNodisturb(this.rightSelectThread);
      }
    },
    Handler_Block() {
      // console.log('拉黑用户');
      bus.$emit(constants.EVENT_BUS_BLOCK_USER, this.rightSelectThread.topic);
    },
    Handler_restartThread() {
      // console.log("重新开始会话");
      this.restartThread(this.rightSelectThread);
    },
    Handler_crm() {
      // 添加客户
      bus.$emit(constants.EVENT_BUS_SHOW_CRM_DRAWER);
    },
    Handler_tickets() {
      // 工单
      bus.$emit(constants.EVENT_BUS_SHOW_TICKET_DRAWER);
    },
    Handler_transfer() {
      // 转接会话
      bus.$emit(constants.EVENT_BUS_SHOW_TRANSFER_DRAWER);
    },
    Handler_summary() {
      // 会话小结
      bus.$emit(constants.EVENT_BUS_SHOW_SUMMARY_DRAWER);
    },
    Handler_close() {
      // 结束会话
      bus.$emit(constants.EVENT_BUS_SHOW_CLOSE_CHAT);
    },
    manualRefreshData() {
      this.$message({
        message: '刷新会话成功',
        type: 'success'
      })
      this.refreshData()
    },
    refreshData() {
      // 当前进行中会话
      this.getThreads();
      // 频道会话
      // this.getChannelThread();
      // 加载历史记录
      this.currentPage = 1
      let payload = { page: this.currentPage - 1, size: this.pageSize };
      this.getThreadHistoryRecords(payload);
      // 工单会话
      // this.getTicketThread();
      // 已经放到getThreads函数action里面调用，无需重复调用
      // 拉取置顶会话
      this.getTopThreads()
      // 拉取星标会话
      this.getStarThreads()
      // 获取crm信息，用于显示标签
      // for (let i = 0; i < this.uniqueHistoryRecords.length; i++) {
      //   const thread = this.uniqueHistoryRecords[i]
      //   let uid = thread.topic.split('/')[1]
      //   this.getCustomerInfoByUid(uid)
      // }
      // 拉取所有技能组
      this.getWorkGroups()
    },
    // 定时刷新拉取
    timerRefreshData() {
      // 当前进行中会话
      this.getThreads();
    },
    isTypeThread(thread) {
      return (
        thread.type === constants.THREAD_TYPE_WORKGROUP ||
        thread.type === constants.THREAD_TYPE_APPOINTED ||
        thread.type === constants.THREAD_TYPE_ROBOT
      );
    },
    isTopThread(thread) {
      return this.userTopThreads.some((th) => {
        return th.topic === thread.topic;
      });
    },
    isNodisturbThread(thread) {
      return this.userNodisturbThreadTopics.some((topic) => {
        return topic === thread.topic;
      });
    },
    isUnreadThread(thread) {
      return this.userUnreadThreadTopics.some((topic) => {
        return topic === thread.topic;
      });
    },
    isVisitorSend(thread) {
      // FIXME: 从服务器加载的thread，不能使用此函数判断
      let uid = thread.topic.split("/")[1]; // 访客uid
      return uid === thread.uid;
    },
    selectThread(thread) {
      this.updateCurrentThread(thread);
    },
    loadMoreThread() {
      // console.log('load more threads')
      let payload = { page: this.currentPage, size: this.pageSize };
      this.getThreadHistoryRecords(payload);
      this.currentPage += 1;
    },
    handleSearchChange(value) {
      // console.log('handleSearchChange:', value)
      this.currentPage = 1;
      if (value === "") {
        let payload = { page: this.currentPage - 1, size: 20 };
        this.getThreadHistoryRecords(payload);
        return;
      }
      // 搜索
      // let payload = { page: this.currentPage - 1, size: 20, content: value };
      // this.searchHistoryThread(payload);
      //
      // console.log('subDomain:', this.userInfo.subDomain)
      let payload2 = { page: this.currentPage - 1, size: 20, content: value, type: 'text', subDomain: this.userInfo.subDomain }
      this.searchMessageArchive(payload2)
    },
    handleCurrentChange(page) {
      this.currentPage = page;
      if (this.search === "") {
        // 加载历史记录
        let payload = { page: this.currentPage - 1, size: this.pageSize };
        this.getThreadHistoryRecords(payload);
      } else {
        // 搜素
        // let payload = {
        //   page: this.currentPage - 1,
        //   size: this.pageSize,
        //   content: this.search,
        // };
        // this.searchHistoryThread(payload);
        let payload2 = { page: this.currentPage - 1, size: this.pageSize, content: value, type: 'text', subDomain: this.userInfo.subDomain }
        this.searchMessageArchive(payload2)
      }
    },
    handleChange(val) {
      // console.log(val)
    },
    showContent(thread) {
      if (thread.content !== null && thread.content !== undefined) {
        if (thread.content.indexOf("请求会话") !== -1) {
          return this.$t("requestThread");
        } else if (thread.content.indexOf("继续会话") !== -1) {
          return this.$t("continueThread");
        } else if (thread.content.indexOf("长时间没有对话") !== -1) {
          return this.$t("autoCloseThread");
        } else if (thread.content.indexOf("客服关闭会话") !== -1) {
          return this.$t("agentCloseThread");
        } else if (thread.content.indexOf("当前无客服在线") !== -1) {
          return this.$t("agentOffline");
        } else if (thread.content.indexOf("visitorConnect") !== -1) {
          return this.$t("visitorConnect");
        } else if (thread.content.indexOf("visitorDisconnect") !== -1) {
          return this.$t("visitorDisconnect");
        } else if (thread.content.indexOf("joinQueueThread") !== -1) {
          return this.$t("joinQueueThread");
        } else if (thread.type === constants.THREAD_TYPE_APPOINTED) {
          return thread.content + this.$t("[appointed]");
        } else {
          // return this.$t(thread.content)
          return thread.content;
        }
      }
      return "";
    },
    fromClient(thread) {
      if (
        thread === null ||
        thread === undefined ||
        thread.client === "" ||
        thread.client === null ||
        thread.client === undefined
      ) {
        return "";
      }
      let client = thread.client;
      if (client.startsWith("web_pc")) {
        client = "webpc";
      } else if (client.startsWith("web_h5")) {
        client = "h5";
      } else if (client.startsWith("web")) {
        client = "web";
      } else if (client.startsWith("android")) {
        client = this.$t("android");
      } else if (client.startsWith("ios")) {
        client = this.$t("ios");
      } else if (client.startsWith("wechat_mp")) {
        client = this.$t("wechat_mp");
      } else if (client.startsWith("wechat_mini")) {
        client = this.$t("wechat_mini");
      } else if (client.startsWith("wechat_kefu")) {
        client = this.$t("wechat_kefu");
      } else if (client.startsWith("flutter_android")) {
        client = this.$t("flutter_android");
      } else if (client.startsWith("flutter_ios")) {
        client = this.$t("flutter_ios");
      } else if (client.startsWith("flutter_web")) {
        client = this.$t("flutter_web");
      } else if (client.startsWith("system")) {
        client = this.$t("system");
      }
      return "[" + client + "]";
    },
    fromWorkGroup(thread) {
      for (let i = 0; i < this.workGroups.length; i++) {
        const wg = this.workGroups[i]
        if (thread.topic.startsWith(wg.wid)) {
          return '[' + wg.nickname + ']'
        }
      }
      if (thread.type === 'appointed') {
        return '[' + this.$t('appointed') + ']'
      }
      return ''
    },
    // 鼠标右键
    rightEvent(thread) {
      // console.log('rightEvent：', thread)
      this.rightSelectThread = thread;
    },
    // 引用第三方组件: https://github.com/GitHub-Laziji/menujs
    onTopContextmenu(event) {
      this.updateCurrentThread(this.rightSelectThread);
      if (this.electron) {
        this.showTopContextMenu();
        return;
      }
      this.$contextmenu({
        items: [
          {
            label: this.$t("notop"),
            icon: "el-icon-bottom",
            onClick: () => {
              // console.log('取消置顶', this.rightSelectThread.nickname, this.rightSelectThread.tid)
              // 取消置顶会话
              this.unmarkThreadTop(this.rightSelectThread);
            },
          },
          {
            label: this.isUnreadThread(this.rightSelectThread)
              ? this.$t("nounread")
              : this.$t("unread"),
            icon: "el-icon-news",
            onClick: () => {
              if (this.isUnreadThread(this.rightSelectThread)) {
                // console.log('取消未读')
                this.unmarkThreadUnread(this.rightSelectThread);
              } else {
                // console.log('标记未读')
                this.markThreadUnread(this.rightSelectThread);
              }
            },
          },
          {
            label: this.$t("updateNote"),
            icon: "el-icon-edit",
            onClick: () => {
              // console.log('设置备注', this.rightSelectThread.nickname, this.rightSelectThread.tid)
              this.threadUpdateNote();
            },
          },
          {
            label: this.isNodisturbThread(this.rightSelectThread)
              ? this.$t("unnodisturb")
              : this.$t("nodisturb"),
            icon: "el-icon-remove-outline",
            onClick: () => {
              if (this.isNodisturbThread(this.rightSelectThread)) {
                // console.log('取消免打扰')
                this.unmarkThreadNodisturb(this.rightSelectThread);
              } else {
                // console.log('免打扰')
                this.markThreadNodisturb(this.rightSelectThread);
              }
            },
          },
          {
            label: this.$t("block"),
            icon: "iconfont icon-block",
            onClick: () => {
              // console.log("拉黑用户");
              bus.$emit(
                constants.EVENT_BUS_BLOCK_USER,
                this.rightSelectThread.topic
              );
            },
            divided: true,
          },
          {
            label: this.$t("crm"),
            icon: "el-icon-circle-plus-outline",
            onClick: () => {
              // 添加客户
              // bus.$emit(constants.EVENT_BUS_THREAD_ADD_CRM, this.rightSelectThread.tid)
              bus.$emit(constants.EVENT_BUS_SHOW_CRM_DRAWER);
            },
          },
          {
            label: this.$t("tickets"),
            icon: "el-icon-tickets",
            onClick: () => {
              // 工单
              bus.$emit(constants.EVENT_BUS_SHOW_TICKET_DRAWER);
            },
          },
          {
            label: this.$t("transfer"),
            icon: "el-icon-refresh",
            onClick: () => {
              // 转接会话
              bus.$emit(constants.EVENT_BUS_SHOW_TRANSFER_DRAWER);
            },
          },
          {
            label: this.$t("summary"),
            icon: "el-icon-document-checked",
            onClick: () => {
              // 会话小结
              bus.$emit(constants.EVENT_BUS_SHOW_SUMMARY_DRAWER);
            },
          },
          {
            label: this.$t("close"),
            icon: "el-icon-close",
            onClick: () => {
              // 结束会话
              bus.$emit(constants.EVENT_BUS_SHOW_CLOSE_CHAT);
            },
          },
        ],
        event,
        customClass: "custom-class",
        zIndex: 3,
        minWidth: 130,
      });
      // return false;
      event.preventDefault();
    },
    // 引用第三方组件: https://github.com/GitHub-Laziji/menujs
    onStarContextmenu(event) {
      this.updateCurrentThread(this.rightSelectThread);
      if (this.electron) {
        this.showStarContextMenu();
        return;
      }
      this.$contextmenu({
        items: [
          {
            label: this.$t("starCancel"),
            icon: "el-icon-star-off",
            onClick: () => {
              // console.log("取消星标" + this.rightSelectThread.topic);
              let payload = { thread: this.rightSelectThread, starType: 0 };
              this.markThreadStar(payload);
            },
          },
          {
            label: this.isUnreadThread(this.rightSelectThread)
              ? this.$t("nounread")
              : this.$t("unread"),
            icon: "el-icon-news",
            onClick: () => {
              if (this.isUnreadThread(this.rightSelectThread)) {
                // console.log('取消未读')
                this.unmarkThreadUnread(this.rightSelectThread);
              } else {
                // console.log('标记未读')
                this.markThreadUnread(this.rightSelectThread);
              }
            },
          },
          {
            label: this.$t("updateNote"),
            icon: "el-icon-edit",
            onClick: () => {
              // console.log('设置备注', this.rightSelectThread.nickname, this.rightSelectThread.tid)
              this.threadUpdateNote();
            },
          },
          {
            label: this.isNodisturbThread(this.rightSelectThread)
              ? this.$t("unnodisturb")
              : this.$t("nodisturb"),
            icon: "el-icon-remove-outline",
            onClick: () => {
              if (this.isNodisturbThread(this.rightSelectThread)) {
                // console.log('取消免打扰')
                this.unmarkThreadNodisturb(this.rightSelectThread);
              } else {
                // console.log('免打扰')
                this.markThreadNodisturb(this.rightSelectThread);
              }
            },
          },
          {
            label: this.$t("block"),
            icon: "iconfont icon-block",
            onClick: () => {
              // console.log("拉黑用户");
              bus.$emit(
                constants.EVENT_BUS_BLOCK_USER,
                this.rightSelectThread.topic
              );
            },
            divided: true,
          },
          {
            label: this.$t("crm"),
            icon: "el-icon-circle-plus-outline",
            onClick: () => {
              // 添加客户
              // bus.$emit(constants.EVENT_BUS_THREAD_ADD_CRM, this.rightSelectThread.tid)
              bus.$emit(constants.EVENT_BUS_SHOW_CRM_DRAWER);
            },
          },
          {
            label: this.$t("tickets"),
            icon: "el-icon-tickets",
            onClick: () => {
              // 工单
              bus.$emit(constants.EVENT_BUS_SHOW_TICKET_DRAWER);
            },
          },
          {
            label: this.$t("transfer"),
            icon: "el-icon-refresh",
            onClick: () => {
              // 转接会话
              bus.$emit(constants.EVENT_BUS_SHOW_TRANSFER_DRAWER);
            },
          },
          {
            label: this.$t("summary"),
            icon: "el-icon-document-checked",
            onClick: () => {
              // 会话小结
              bus.$emit(constants.EVENT_BUS_SHOW_SUMMARY_DRAWER);
            },
          },
          {
            label: this.$t("close"),
            icon: "el-icon-close",
            onClick: () => {
              // 结束会话
              bus.$emit(constants.EVENT_BUS_SHOW_CLOSE_CHAT);
            },
          },
        ],
        event,
        customClass: "custom-class",
        zIndex: 3,
        minWidth: 130,
      });
      // return false;
      event.preventDefault();
    },
    // 引用第三方组件: https://github.com/GitHub-Laziji/menujs
    onContextmenu(event) {
      // console.log('onContextmenu：', this.rightSelectThread)
      this.updateCurrentThread(this.rightSelectThread);
      if (this.electron) {
        this.showCurrentContextMenu();
        return;
      }
      // TODO: 会话置顶
      // TODO: 判断是否已经结束或小结，如果没有，则提示且不允许删除
      this.$contextmenu({
        items: [
          {
            label: this.$t("top"),
            icon: "el-icon-top",
            onClick: () => {
              // console.log('置顶', this.rightSelectThread.nickname, this.rightSelectThread.tid)
              // 标记置顶会话
              this.markThreadTop(this.rightSelectThread);
            },
          },
          {
            label: this.isUnreadThread(this.rightSelectThread)
              ? this.$t("nounread")
              : this.$t("unread"),
            icon: "el-icon-news",
            onClick: () => {
              if (this.isUnreadThread(this.rightSelectThread)) {
                // console.log('取消未读')
                this.unmarkThreadUnread(this.rightSelectThread);
              } else {
                // console.log('标记未读')
                this.markThreadUnread(this.rightSelectThread);
              }
            },
          },
          {
            label: this.$t("starSet"),
            icon: "el-icon-star-off",
            children: [
              {
                label: this.$t("star1"),
                icon: "el-icon-star-on menu-star-red",
                // customClass: "menu-star-red",
                onClick: () => {
                  // console.log("星标1" + this.rightSelectThread.topic);
                  let payload = { thread: this.rightSelectThread, starType: 1 };
                  this.markThreadStar(payload);
                },
              },
              {
                label: this.$t("star2"),
                icon: "el-icon-star-on menu-star-yellow",
                // customClass: "menu-star-yellow",
                onClick: () => {
                  // console.log("星标2" + this.rightSelectThread.topic);
                  let payload = { thread: this.rightSelectThread, starType: 2 };
                  this.markThreadStar(payload);
                },
              },
              {
                label: this.$t("star3"),
                icon: "el-icon-star-on menu-star-blue",
                // customClass: "menu-star-blue",
                onClick: () => {
                  // console.log("星标3" + this.rightSelectThread.topic);
                  let payload = { thread: this.rightSelectThread, starType: 3 };
                  this.markThreadStar(payload);
                },
              },
              {
                label: this.$t("star4"),
                icon: "el-icon-star-on menu-star-green",
                // customClass: "menu-star-green",
                onClick: () => {
                  // console.log("星标4" + this.rightSelectThread.topic);
                  let payload = { thread: this.rightSelectThread, starType: 4 };
                  this.markThreadStar(payload);
                },
              },
            ],
          },
          {
            label: this.$t("updateNote"),
            icon: "el-icon-edit",
            onClick: () => {
              // console.log('设置备注', this.rightSelectThread.nickname, this.rightSelectThread.tid)
              this.threadUpdateNote();
            },
          },
          // {
          //   label: this.$t("closeThread"),
          //   icon: "el-icon-close",
          //   onClick: () => {
          //     // console.log('结束会话', this.rightSelectThread.nickname, this.rightSelectThread.tid)
          //     // 标记删除会话
          //     // this.markThreadDeleted(this.rightSelectThread.tid);
          //     // 结束会话
          //     bus.$emit(
          //       constants.EVENT_BUS_THREAD_AGENT_CLOSE,
          //       this.rightSelectThread.tid
          //     );
          //   },
          // },
          {
            label: this.isNodisturbThread(this.rightSelectThread)
              ? this.$t("unnodisturb")
              : this.$t("nodisturb"),
            icon: "el-icon-remove-outline",
            onClick: () => {
              if (this.isNodisturbThread(this.rightSelectThread)) {
                // console.log('取消免打扰')
                this.unmarkThreadNodisturb(this.rightSelectThread);
              } else {
                // console.log('免打扰')
                this.markThreadNodisturb(this.rightSelectThread);
              }
            },
          },
          {
            label: this.$t("block"),
            icon: "iconfont icon-block",
            onClick: () => {
              // console.log("拉黑用户");
              bus.$emit(
                constants.EVENT_BUS_BLOCK_USER,
                this.rightSelectThread.topic
              );
            },
            divided: true,
          },
          {
            label: this.$t("crm"),
            icon: "el-icon-circle-plus-outline",
            onClick: () => {
              // 添加客户
              // bus.$emit(constants.EVENT_BUS_THREAD_ADD_CRM, this.rightSelectThread.tid)
              bus.$emit(constants.EVENT_BUS_SHOW_CRM_DRAWER);
            },
          },
          {
            label: this.$t("tickets"),
            icon: "el-icon-tickets",
            onClick: () => {
              // 工单
              bus.$emit(constants.EVENT_BUS_SHOW_TICKET_DRAWER);
            },
          },
          {
            label: this.$t("transfer"),
            icon: "el-icon-refresh",
            onClick: () => {
              // 转接会话
              bus.$emit(constants.EVENT_BUS_SHOW_TRANSFER_DRAWER);
            },
          },
          {
            label: this.$t("summary"),
            icon: "el-icon-document-checked",
            onClick: () => {
              // 会话小结
              bus.$emit(constants.EVENT_BUS_SHOW_SUMMARY_DRAWER);
            },
          },
          {
            label: this.$t("close"),
            icon: "el-icon-close",
            onClick: () => {
              // 结束会话
              bus.$emit(constants.EVENT_BUS_SHOW_CLOSE_CHAT);
            },
          },
        ],
        event,
        customClass: "custom-class",
        zIndex: 3,
        minWidth: 130,
      });
      return false;
      // event.preventDefault();
    },
    // 引用第三方组件: https://github.com/GitHub-Laziji/menujs
    onHistoryContextmenu(event) {
      // console.log('onHistoryContextmenu:', this.rightSelectThread)
      this.updateCurrentThread(this.rightSelectThread);
      if (this.electron) {
        this.showHistoryContextMenu();
        return;
      }
      this.$contextmenu({
        items: [
          {
            label: this.$t("top"),
            icon: "el-icon-top",
            onClick: () => {
              // console.log('置顶', this.rightSelectThread.nickname, this.rightSelectThread.tid)
              // 置顶会话
              this.markThreadTop(this.rightSelectThread);
            },
          },
          {
            label: this.isUnreadThread(this.rightSelectThread)
              ? this.$t("nounread")
              : this.$t("unread"),
            icon: "el-icon-news",
            onClick: () => {
              if (this.isUnreadThread(this.rightSelectThread)) {
                // console.log('取消未读')
                this.unmarkThreadUnread(this.rightSelectThread);
              } else {
                // console.log('标记未读')
                this.markThreadUnread(this.rightSelectThread);
              }
            },
          },
          {
            label: this.$t("starSet"),
            icon: "el-icon-star-off",
            children: [
              {
                label: this.$t("star1"),
                icon: "el-icon-star-on menu-star-red",
                // customClass: "menu-star-red",
                onClick: () => {
                  // console.log("星标1" + this.rightSelectThread.topic);
                  let payload = { thread: this.rightSelectThread, starType: 1 };
                  this.markThreadStar(payload);
                },
              },
              {
                label: this.$t("star2"),
                icon: "el-icon-star-on menu-star-yellow",
                // customClass: "menu-star-yellow",
                onClick: () => {
                  // console.log("星标2" + this.rightSelectThread.topic);
                  let payload = { thread: this.rightSelectThread, starType: 2 };
                  this.markThreadStar(payload);
                },
              },
              {
                label: this.$t("star3"),
                icon: "el-icon-star-on menu-star-blue",
                // customClass: "menu-star-blue",
                onClick: () => {
                  // console.log("星标3" + this.rightSelectThread.topic);
                  let payload = { thread: this.rightSelectThread, starType: 3 };
                  this.markThreadStar(payload);
                },
              },
              {
                label: this.$t("star4"),
                icon: "el-icon-star-on menu-star-green",
                // customClass: "menu-star-green",
                onClick: () => {
                  // console.log("星标4" + this.rightSelectThread.topic);
                  let payload = { thread: this.rightSelectThread, starType: 4 };
                  this.markThreadStar(payload);
                },
              },
            ],
          },
          {
            label: this.$t("updateNote"),
            icon: "el-icon-edit",
            onClick: () => {
              // console.log('设置备注', this.rightSelectThread.nickname, this.rightSelectThread.tid)
              this.threadUpdateNote();
            },
          },
          {
            label: this.isNodisturbThread(this.rightSelectThread)
              ? this.$t("unnodisturb")
              : this.$t("nodisturb"),
            icon: "el-icon-remove-outline",
            onClick: () => {
              if (this.isNodisturbThread(this.rightSelectThread)) {
                // console.log('取消免打扰')
                this.unmarkThreadNodisturb(this.rightSelectThread);
              } else {
                // console.log('免打扰')
                this.markThreadNodisturb(this.rightSelectThread);
              }
            },
          },
          {
            label: this.$t("block"),
            icon: "iconfont icon-block",
            onClick: () => {
              // console.log("拉黑用户");
              bus.$emit(
                constants.EVENT_BUS_BLOCK_USER,
                this.rightSelectThread.topic
              );
            },
          },
          {
            label: this.$t("restartChat"),
            icon: "el-icon-chat-round",
            onClick: () => {
              // console.log("重新开始会话");
              this.restartThread(this.rightSelectThread);
            },
            divided: true,
          },
          {
            label: this.$t("crm"),
            icon: "el-icon-circle-plus-outline",
            onClick: () => {
              // 添加客户
              bus.$emit(constants.EVENT_BUS_SHOW_CRM_DRAWER);
            },
          },
          {
            label: this.$t("tag"),
            icon: "el-icon-circle-plus-outline",
            onClick: () => {
              // 添加标签
              bus.$emit(constants.EVENT_BUS_SHOW_TAG_DIALOG);
            },
          },
          {
            label: this.$t("tickets"),
            icon: "el-icon-tickets",
            onClick: () => {
              // 工单
              bus.$emit(constants.EVENT_BUS_SHOW_TICKET_DRAWER);
            },
          },
          {
            label: this.$t("transfer"),
            icon: "el-icon-refresh",
            onClick: () => {
              // 转接会话
              bus.$emit(constants.EVENT_BUS_SHOW_TRANSFER_DRAWER);
            },
          },
          {
            label: this.$t("summary"),
            icon: "el-icon-document-checked",
            onClick: () => {
              // 会话小结
              bus.$emit(constants.EVENT_BUS_SHOW_SUMMARY_DRAWER);
            },
          },
        ],
        event,
        customClass: "custom-class",
        zIndex: 3,
        minWidth: 130,
      });
      // return false;
      event.preventDefault();
    },
    // 更新会话访客昵称
    threadUpdateNote() {
      let nickname = this.rightSelectThread.nickname;
      let uid = this.rightSelectThread.topic.split("/")[1]; // 访客uid
      this.$prompt(this.$t("updateNote"), this.$t("tip"), {
        inputValue: nickname,
        confirmButtonText: this.$t("ok"),
        cancelButtonText: this.$t("cancel"),
      })
        .then(({ value }) => {
          // console.log(value)
          if (value !== undefined && value !== null && value.length > 0) {
            let payload = { uid: uid, nickname: value };
            this.updateNote(payload);
          }
        })
        .catch(() => {
          // 取消
          // this.$message({ type: 'info', message: '取消输入' })
        });
    },
    // 检测是否在30s之内，超过则超时
    // TODO: 最后10s显示倒计时数字
    // FIXME: 应当以距今时间最长的一条消息为准，非当前最新消息
    // FIXME: 直接从服务器加载的thread.uid !== this.userInfo.uid, 即使最后一条消息是客服发送
    threadWillOutOfTime(thread) {
      // 过滤掉已经关闭的 和 最后更新消息为当前用户的会话
      if (thread.delay) {
        if (thread.delay > 20 && thread.delay < 30) {
          return true;
        }
      }
      return false;
    },
    threadOutOfTime(thread) {
      // 过滤掉已经关闭的 和 最后更新消息为当前用户的会话
      if (thread.delay) {
        if (thread.delay >= 30) {
          return true;
        }
      }
      return false;
    },
    checkTimeoutThread() {
      // console.log("checkTimeoutThread");
      // 检测-thread会话是否超时未回复
      for (let i = 0; i < this.userThreads.length; i++) {
        const thread = this.userThreads[i];
        let uid = thread.topic.split("/")[1]; // 访客uid
        if (
          !thread.closed && // 会话未结束
          thread.uid === uid // 会话最近一条消息是访客发送的
          // thread.uid !== this.userInfo.uid &&
          // thread.uid !== constants.SYSTEM_NOTIFICATION_USER_UUID
        ) {
          //
          // let timestamp = moment(thread.timestamp); // FIXME: 时间戳应该选择thread会话内访客最早发送的那条消息的时间戳
          // let now = moment(new Date());
          // let delay = now.diff(timestamp, "seconds");
          // // console.log('delay:', delay)
          // let payload = { tid: thread.tid, delay: delay };
          // this.updateThreadDelay(payload);
          // if (delay > 20 && delay < 30) {
          //   console.log('TODO: 会话即将超时，倒计时10s')
          //   Vue.set(this.userThreads[i], 'delay', delay)
          // } else if (delay >= 30) {
          //   console.log('TODO: 会话超时')
          //   Vue.set(this.userThreads[i], 'delay', delay)
          // }
        }
      }
      // 判断连接状态，如果断开，则调用http-rest接口拉取会话thread
      if (
        this.connectionStatus != constants.STOMP_CONNECTION_STATUS_CONNECTED
      ) {
        // this.getThreads(); // TODO: 数据库压力过大，暂时注释掉
      }
    },
  },
  mounted() {
    // 定时检测-thread会话是否超时未回复
    // this.timer = setInterval(this.checkTimeoutThread, 1000 * 10)
    this.refreshTimer = setInterval(this.timerRefreshData, 1000 * 60 * 5);
    //
    let app = this;
    window.addEventListener("online", function() {
      // console.log('监听：网络连接上了')
      // 拉取未读消息
      let payload = { page: 0, size: 20 };
      app.getUnreadMessagesAgent(payload);
      // 拉取会话，会执行多于动作，去掉
      // app.refreshData();
      // 当前进行中会话
      app.getThreads();
      // 拉取置顶会话
      // app.getTopThreads()
      // 拉取星标会话
      // app.getStarThreads()
    });
    window.addEventListener("offline", function() {
      // console.log('监听：网络断开了')
      // 即使断开了，也尝试拉取一下未读消息
      // let payload = { page: 0, size: 20 };
      // app.getUnreadMessagesAgent(payload);
      // 拉取会话
      // app.refreshData();
    });
    // 消息预知
    bus.$on(constants.EVENT_BUS_MESSAGE_PREVIEW, (message) => {
      // console.log('preview:', message.content)
      // if (message.thread.tid === this.userCurrentThread.tid) {
      //   if (message.content.trim().length > 0) {
      //     app.inputTipVisible = true;
      //     this.previewContent = app.inputing + message.content;
      //     // if (this.previewContent.length > 15) {
      //     //   this.previewContent = this.previewContent.substring(0, 12) + '...'
      //     // }
      //   } else {
      //     this.previewContent = "";
      //     app.inputTipVisible = false;
      //   }
      //   // 5s 定期清空状态
      //   setTimeout(function() {
      //     app.inputTipVisible = false;
      //   }, 6000);
      // }
    });
  },
  beforeDestroy() {
    // clearInterval(this.timer)
    clearInterval(this.refreshTimer);
  },
  filters: {
    // 将日期过滤为 hour:minutes
    time(value) {
      if (typeof value === "string") {
        return moment(value).format("MM-DD HH:mm");
      } else {
        return value;
      }
    },
  },
};
</script>

<!-- 注意：如果要修改contextmenujs样式，style不能添加scoped -->
<style>
#bd-aside {
  width: 100%;
  height: 100%;
  float: left;
}
#bd-aside .thread-search {
  padding: 12px 12px 12px 12px;
}
#bd-aside .list-item {
  padding: 5px 5px 5px 5px;
  margin-bottom: 0px;
  border-bottom: 1px solid beige;
  /* height: 50px; */
  height: auto;
}
#bd-aside .list-item:hover {
  background-color: rgb(220, 220, 220);
}
.active {
  background-color: darkkhaki;
}
#bd-aside .list-item .avatar {
  border-radius: 2px;
  margin-right: 2px;
}
#bd-aside li {
  list-style: none;
}
#bd-aside .list-left {
  margin-top: 4px;
  margin-left: 2px;
  width: 25px;
  height: 25px;
  float: left;
}
#bd-aside .list-right {
  margin-left: 52px;
}
#bd-aside .list-right .top {
  margin-top: 2px;
  text-align: left;
}
#bd-aside .list-right-ticket {
  margin-left: 5px;
}
#bd-aside .list-right-ticket .top {
  margin-top: 2px;
  text-align: left;
}
#bd-aside span.nickname {
  display: inline-block;
  vertical-align: top;
  font-size: 14px;
  width: calc(100% - 100px);
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
#bd-aside span.timestamp {
  float: right;
  color: gray;
  font-size: 12px;
  vertical-align: top;
  width: 68px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
#bd-aside .list-right .bottom {
  text-align: left;
}
#bd-aside .list-right-ticket .bottom {
  text-align: left;
}
#bd-aside .list-right .bottom-queue {
  width: 90%;
  text-align: left;
}
#bd-aside .list-right .bottom .content {
  display: inline-block;
  vertical-align: top;
  font-size: 12px;
  color: gray;
  width: calc(100% - 25px);
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
#bd-aside .list-right .bottom .star {
  font-size: 14px;
  float: right;
}
#bd-aside .list-right .unreadCount {
  margin-top: 4px;
  float: right;
  font-size: 10px;
  width: 12px;
  height: 12px;
  line-height: 12px;
  text-align: center;
  border-radius: 5px;
  color: white;
  background-color: red;
}
.custom-class .menu_item__available:hover,
.custom-class .menu_item_expand {
  background: #ffecf2 !important;
  color: #ff4050 !important;
}
.menu-star-red {
  color: red !important;
}
.menu-star-yellow {
  color: yellow !important;
}
.menu-star-blue {
  color: blue !important;
}
.menu-star-green {
  color: green !important;
}
</style>
<style lang="scss" scoped>
td.table_td_h {
  padding: 17px 0;
}
.right-menu {
  display: none;
  position: fixed;
  background: #fff;
  border: 1px solid #bababa;
  border-radius: 3px;
  z-index: 999;
  box-shadow: 2px 2px 3px 0px rgba(51, 42, 40, 0.7);
  border-radius: 1px;
  p {
    margin: 0;
    display: block;
    width: 200px;
    height: 35px;
    line-height: 35px;
    text-align: left;
    padding: 0 24px 0 32px;
    color: #000000;
    cursor: pointer;
    font-size: 15px;
    border-bottom: 1px solid #e8eaed;
    &:hover {
      background: #e8eaed;
    }
  }
  .menu-disable {
    cursor: no-drop;
    color: #80868b;
  }
}
</style>
